var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.31 0H1.653c-.602 0-.902.71-.465 1.12l5.057 5.055v5.63c0 .218.082.437.273.546l2.187 1.53a.66.66 0 0 0 1.038-.546v-7.16l5.03-5.055C15.21.71 14.91 0 14.309 0Z",
    fill: "currentColor"
  })));
};
export default SvgFilterIcon;